export const VISIT_SITE_LABEL = "Visit Site";

export const REGISTER_TYPE_CHARACTER_LIMIT = 22;
